import React from 'react';
import NeptuneLogo from 'assets/logo/neptune-logo.svg?react';

import { bemBlock, Layout } from '@neptune/shared/venus-ui';

import { useMobileView } from 'common/hooks/useMobileView';
import LoadingIndicator from 'components/loading-indicator/LoadingIndicator';

import './SplashScreen.less';

const block = bemBlock('splash-screen');

const SplashScreen: React.FC = () => {
  useMobileView();
  return (
    <Layout.Column alignItems="center" justifyContent="center" className={block()}>
      <NeptuneLogo className={block('logo')} />
      <LoadingIndicator isVisible />
    </Layout.Column>
  );
};

export default SplashScreen;
